import { useMemo } from 'react';
import { formatPrice, formatVariantPrice } from '../molecules/catalog/products/price/price.helper';

export const usePrice = (
    data?: {
        amount: number;
        baseAmount?: number;
        currencyCode?: string;
    } | null
) => {
    const currency = 'VND';
    const locale = 'vi';
    const currencyCode = data?.currencyCode || currency || 'VND';

    const { amount, baseAmount } = {
        ...data,
    };

    const value = useMemo(() => {
        if (typeof amount !== 'number' || !currencyCode) {
            return '';
        }

        const currentLocale = locale ?? 'vi';
        return baseAmount
            ? formatVariantPrice({
                  amount,
                  baseAmount,
                  currencyCode,
                  locale: currentLocale,
              })
            : formatPrice({ amount, currencyCode, locale: currentLocale });
    }, [amount, baseAmount, currencyCode, locale]);

    return typeof value === 'string' ? { price: value, basePrice: null, discount: null } : value;
};
